import { writable } from 'svelte/store';

// const DEFAULT_DATA = {};

// const { subscribe, set, update } = writable(DEFAULT_DATA);

// const setCardInfo = cardInfo => update(store => {
//     return {
//         ...store, cardInfo
//     };
// });

// const reset = () => {
//     set(DEFAULT_DATA);
// };

// export default {
//     subscribe, setCardInfo, reset
// }

const orderId = writable('');

const orderInfo = writable({});

export {
    orderId,
    orderInfo
}